import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useToast } from "hooks/toast";

import { LanguageSelector } from "components/LanguageSelector";

import { ChangePassword as ChangePasswordTemplate } from "features/auth/ChangePassword";
import { LeftTemplate } from "features/auth/LeftTemplate";

export const ChangePassword: React.FC = () => {
  const [changePass, setChangePass] = useState<boolean>(false);
  const [succeseMessageReturnAPI, setSuccessMessageReturnAPI] =
    useState<string>("");
  const { guid } = useParams();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (changePass) {
      setChangePass(false);
      navigate("/");

      addToast({
        type: "success",
        title: t("account.passwordChanged"),
        description: succeseMessageReturnAPI || t("changePassword.passwordUpdated"),
      });
    }
  }, [changePass]);

  return (
    <div style={{ display: "flex", flexDirection: "row", position: "relative" }}>
      <div style={{ position: "absolute", top: 16, right: 16, zIndex: 10 }}>
        <LanguageSelector />
      </div>
      <LeftTemplate backgroundImage="default" />
      <ChangePasswordTemplate
        guid={guid ?? ""}
        navigate={navigate}
        navigateTo="/"
        setChangedPassword={setChangePass}
        setSuccessMessageReturnAPI={setSuccessMessageReturnAPI}
      />
    </div>
  );
};
